<script setup lang="ts">
    const props = withDefaults(defineProps<{
        showText?: boolean,
        loadingIconClass?: string,
        loadingTextClass?: string,
        loadingText?: string,
    }>(), {
        showText: true,
        loadingIconClass: 'mr-3',
        loadingTextClass: 'text-gray-600 dark:text-gray-200',
        loadingText: 'Loading',
    });
    const show = defineModel('loading');
</script>

<template>
    <div v-bind="$attrs" v-if="show">
        <slot name="loadingIcon">
            <Icon :class="props.loadingIconClass" name="svg-spinners:ring-resize" />
        </slot>
        <slot name="loadingText">
            <span :class="props.loadingTextClass" v-if="props.showText">{{ props.loadingText }}</span>
        </slot>
    </div>
</template>